import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { createDeck } from '@/services/api'
import { useToast } from '@/hooks/useToast'

interface DeckFormData {
  name: string
  description: string
  universeId: number
  is_public: boolean
  is_collaborative: boolean
}

export function useDeckCreation() {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { toast } = useToast()

  const createNewDeck = async (data: DeckFormData) => {
    setLoading(true)
    try {
      const response = await createDeck(data)
      toast({
        title: "Success",
        description: "Deck created successfully",
      })
      navigate(`/decks/${response.data.data.id}`)
    } catch (error: any) {
      toast({
        variant: "destructive",
        title: "Error",
        description: error.response?.data?.message || "Failed to create deck",
      })
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    createNewDeck
  }
} 